import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailSettingComponent } from '../email-setting/email-setting.component';
import { EmailAttachmentSettings } from '../email-settings.types';

@Component({
  standalone: true,
  imports: [CommonModule, EmailSettingComponent],
  selector: 'mode-email-attachments',
  templateUrl: './email-attachments.component.html',
  styleUrls: ['./email-attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailAttachmentsComponent {
  @Input() selections!: EmailAttachmentSettings;
  @Input() disableAttachments = false;
  @Output() attachmentsSelected = new EventEmitter<Partial<EmailAttachmentSettings>>();
}
